var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 统计上报系统
 */
import qs from "qs";
/**
 * 当前H5环境
 */
const environment = /^(?:m\d*|h\d*)\.chelun\.com$/.test(window.location.host)
    ? "production"
    : "development";
/**
 * 埋点上报的URL地址
 */
const uploadHost = environment === "production"
    ? "//webapiproxy.chelun.com"
    : "//webapiproxy-test.oa.com";
/**
 * 浏览器端用户唯一UID，依赖COOKIE追踪
 * 1、cookie被清除会重新生成不同的UID
 * 2、切换浏览器也会重新生成不同的UID
 */
export let uuid = undefined;
/**
 * 准备阶段，此函数可以单独调用完成
 */
export function statePrepare() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(uploadHost + `/clcuid?__c=${Date.now()}`, {
                credentials: "include"
            });
            const result = yield response.json();
            uuid = result.clcuid;
        }
        catch (error) {
            environment === "development" && console.log(error);
        }
    });
}
/**
 * 统计上报接口
 *
 * @param key 统计的ID
 * @param value 统计的值
 * @param extra 统计的额外字段，为JSON对象
 */
export function __S(key, value = "", extra = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        /**
         * 如果页面的uuid没有准备就绪，需要预取UUID
         */
        if (typeof uuid === "undefined") {
            yield statePrepare();
        }
        /**
         * 如果还无法获取uuid，则直接退出
         */
        if (typeof uuid !== "string" || !uuid) {
            environment === "development" &&
                console.error("Reporting was interrupted because uuid could not be obtained");
            return;
        }
        // 当前页面的唯一id
        let appKey = window.location.pathname.replace(/index\.html$/, "");
        appKey = window.location.host + "/" + appKey.replace(/^\/*|\/*$/g, "");
        // 当前页面的URL
        try {
            yield fetch(uploadHost + `/h5Recive/ajaxPost?__c=${Date.now()}`, {
                method: "POST",
                body: qs.stringify({
                    user_key: uuid,
                    app_key: appKey,
                    page: window.location.href,
                    type: environment === "production" ? "idEvent" : "idEvent_test",
                    msg: JSON.stringify(Object.assign({ [key]: value }, extra))
                }),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
                },
                credentials: "include"
            });
        }
        catch (error) {
            environment === "development" && console.error(error);
        }
    });
}
